import { render } from "./Index.vue?vue&type=template&id=19bd69a0&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=19bd69a0&lang=scss&scoped=true"

import exportComponent from "/Users/laiwendong/Documents/电商/code/annilux-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19bd69a0"]])

export default __exports__